/**
 * @file Logging helpers (for wrapping wvus-client-logger or other logging related functions).
 */

import WvusClientLogger from "wvus-client-logger";

export function clientLogger(logglyKey) {
  // Return instance if it exists
  if (globalThis.wvusLogger) {
    return globalThis.wvusLogger;
  }

  // Create new instance
  const environment = window.location.host;
  const webproperty = "wvusBettermode";
  const source = `wvusBettermode - ${window.location.pathname}`;
  const sendConsoleErrors = true;

  const windowWvusLogger = new WvusClientLogger({
    logglyKey,
    webProperty: webproperty,
    env: environment,
    source: source, // Optional
    sendConsoleErrors: sendConsoleErrors
  });

  globalThis.wvusLogger = windowWvusLogger;
  return globalThis.wvusLogger;
}
